import { initialPopup } from 'hooks/constants'
import { PopupReturnTypeWithPayload } from 'hooks/usePopup'
import {
  CantProceedWithDefaultReceivableAccountPopupPayload,
  DeleteBankAccountPopupPayload,
  SetAnotherDefaultReceivableAccountPopupPayload,
  SetAsDefaultReceivableAccountPopupPayload,
  TDefaultReceivableAccountAction,
  ThisAccountIsDefaultReceivableAccountPopupPayload,
  VerifyDepositsPopupPayload
} from './types'

export const OPEN_MOOV_PAYMENT_METHODS_STATE_KEY = 'openMoovPaymentMethods'

export const DEFAULT_RECEIVABLE_ACCOUNT_POPUP_TITLES = {
  thisAccountIsDefault: {
    delete: 'This is your default receivable account',
    changePurpose: 'This is your default receivable account'
  },
  setAnotherDefault: {
    delete: 'Choose a new default receivable account',
    changePurpose: 'Choose a new default receivable account'
  },
  cantProceed: {
    delete: "Can't delete this account",
    changePurpose: "Can't update this account"
  }
} as const

export const getDefaultReceivablePopupTitle = (
  popup: keyof typeof DEFAULT_RECEIVABLE_ACCOUNT_POPUP_TITLES,
  action?: TDefaultReceivableAccountAction
) => DEFAULT_RECEIVABLE_ACCOUNT_POPUP_TITLES[popup][action ?? 'delete']

export const deleteBankAccountPopupWithPayload: PopupReturnTypeWithPayload<DeleteBankAccountPopupPayload> =
  {
    state: {
      ...initialPopup?.state,
      payload: {
        uuid: '',
        name: '',
        business_account_id: ''
      }
    },
    actions: {
      ...initialPopup.actions,
      setState: () => undefined
    }
  }

export const verifyDepositsPopupWithPayload: PopupReturnTypeWithPayload<VerifyDepositsPopupPayload> =
  {
    state: {
      ...initialPopup?.state,
      payload: {
        uuid: '',
        name: '',
        business_account_id: '',
        account_number: '0000'
      }
    },
    actions: {
      ...initialPopup.actions,
      setState: () => undefined
    }
  }

export const setAsDefaultReceivableAccountPopupWithPayload: PopupReturnTypeWithPayload<SetAsDefaultReceivableAccountPopupPayload> =
  {
    state: {
      ...initialPopup?.state,
      payload: {
        uuid: '',
        name: '',
        business_account_id: ''
      }
    },
    actions: {
      ...initialPopup.actions,
      setState: () => undefined
    }
  }

export const cantProceedWithDefaultReceivableAccountWithPayload: PopupReturnTypeWithPayload<CantProceedWithDefaultReceivableAccountPopupPayload> =
  {
    state: {
      ...initialPopup?.state,
      payload: {
        name: ''
      }
    },
    actions: {
      ...initialPopup.actions,
      setState: () => undefined
    }
  }

export const thisAccountIsDefaultReceivableAccountWithPayload: PopupReturnTypeWithPayload<ThisAccountIsDefaultReceivableAccountPopupPayload> =
  {
    state: {
      ...initialPopup?.state,
      payload: {
        name: '',
        callback: () => undefined
      }
    },
    actions: {
      ...initialPopup.actions,
      setState: () => undefined
    }
  }

export const setAnotherDefaultReceivableAccountPopupWithPayload: PopupReturnTypeWithPayload<SetAnotherDefaultReceivableAccountPopupPayload> =
  {
    state: {
      ...initialPopup?.state,
      payload: {
        name: '',
        uuid: '',
        business_account_id: '',
        listOfAvailableAccountsToSetAsDefault: []
      }
    },
    actions: {
      ...initialPopup.actions,
      setState: () => undefined
    }
  }
